import { render, staticRenderFns } from "./EsclarecimentoImpugnacao.vue?vue&type=template&id=19718e12&scoped=true"
import script from "./EsclarecimentoImpugnacao.vue?vue&type=script&lang=js"
export * from "./EsclarecimentoImpugnacao.vue?vue&type=script&lang=js"
import style0 from "./EsclarecimentoImpugnacao.vue?vue&type=style&index=0&id=19718e12&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19718e12",
  null
  
)

export default component.exports